import { AnalyticsEvent, AnalyticsEventParams } from '../../analytics.event';

export type ButtonClickEventContext = Record<string, string>;

export class ButtonClickEvent extends AnalyticsEvent {
    constructor(buttonID: string, form: string, context?: ButtonClickEventContext) {
        const params: AnalyticsEventParams = {
            button_id: buttonID,
            form
        };

        if (context) {
            params['context'] = context;
        }

        super('button_click', params);
    }
}
